import axios from 'axios';
import AccessControlInterceptor from '@/axios/interceptors/accesscontrol.interceptor';
import { getDbId, LS_TOKEN } from '@/shared/local.storage.utils';

axios.defaults.baseURL = process.env.VUE_APP_REST_API_URL || 'http://localhost:3000';

// Add a request interceptor
axios.interceptors.request.use((config) => {

  config.headers['scapin-token'] = localStorage.getItem(LS_TOKEN);
  config.headers['scapin-conkey'] = 'account-admin'
  config.headers['scapin-account'] = getDbId()

  // Do something before request is sent
  return config;

}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use((response) => {
  // console.log('interceptor.reponse :', {...response})
  // Do something with response data
  AccessControlInterceptor.Response(response);
  return response;

}, (error) => {
  // console.log('interceptor.error :', {...error})
  // Do something with response error
  AccessControlInterceptor.ResponseError(error);
  return Promise.reject(error);
});

export default axios;
